import { axiosInstance } from "@/api/axiosInstance";

  export const giftsService = {
  // GET /api/gifts
  getGifts: async (page = 0, size = 10, type = null) => {
    try {
      const response = await axiosInstance.get("/api/gifts/get-all", {
        params: { page, size, ...(type && { type }) },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching gifts:", error.message);
      throw error;
    }
  },

  // GET /api/gifts/displayed
  getDisplayedGifts: async (page = 0, size = 10, type = null) => {
    try {
      const response = await axiosInstance.get("/api/gifts/displayed", {
        params: { page, size, ...(type && { type }) },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching displayed gifts:", error.message);
      throw error;
    }
  },

  // GET /api/gifts/{id}
  getGiftById: async (id) => {
    try {
      const response = await axiosInstance.get(`/api/gifts/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching gift with ID ${id}:`, error.message);
      throw error;
    }
  },

// giftsService.js

// POST /api/gifts/add (with file upload)
    createGift: async (giftDto, file) => {
      try {
        const formData = new FormData();
        if (file) {
          formData.append("file", file);
        }

        // Convert giftDto to query parameters
        const params = new URLSearchParams();
        console.log(giftDto)
        // Add all required parameters
        if (giftDto.name) params.append('name', giftDto.name);
        if (giftDto.costPoints != null) params.append('costPoints', giftDto.costPoints.toString());
        if (giftDto.description) params.append('description', giftDto.description);
        if (giftDto.type) params.append('type', giftDto.type);
        if (giftDto.cardAmount != null) params.append('cardAMount', giftDto.cardAmount.toString());

        // An empty multipart body is rejected by the server (400), so only send multipart when there is a file
        const response = await axiosInstance.post(`/api/gifts/add?${params.toString()}`,
            file ? formData : null,
            file ? { headers: { "Content-Type": "multipart/form-data" } } : undefined
        );
        return response.data;
      } catch (error) {
        console.error("Error creating gift:", error.message);
        throw error;
      }
    },

// PUT /api/gifts/update/{id} (with file upload)
    updateGift: async (id, giftDto, file) => {
      try {
        const formData = new FormData();
        if (file) {
          formData.append("file", file);
        }

        // Convert giftDto to query parameters
        const params = new URLSearchParams();

        // Add all required parameters
        if (giftDto.name) params.append('name', giftDto.name);
        if (giftDto.costPoints != null) params.append('costPoints', giftDto.costPoints.toString());
        if (giftDto.description) params.append('description', giftDto.description);
        if (giftDto.type) params.append('type', giftDto.type);
        if (giftDto.cardAmount != null) params.append('cardAMount', giftDto.cardAmount.toString());
        if (giftDto.display != null) params.append('display', giftDto.display.toString());

        // An empty multipart body is rejected by the server (400), so only send multipart when there is a file
        const response = await axiosInstance.put(`/api/gifts/update/${id}?${params.toString()}`,
            file ? formData : null,
            file ? { headers: { "Content-Type": "multipart/form-data" } } : undefined
        );
        return response.data;
      } catch (error) {
        console.error(`Error updating gift with ID ${id}:`, error.message);
        throw error;
      }
    },
  // DELETE /api/gifts/{id}
  deleteGift: async (id) => {
    try {
      const response = await axiosInstance.delete(`/api/gifts/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting gift with ID ${id}:`, error.message);
      throw error;
    }
  },
};

export const giftRequestsService = {
  // GET /api/gift-requests
  getGiftRequests: async (page = 0, size = 10, status = null) => {
    try {
      const response = await axiosInstance.get("/api/gift-requests", {
        params: { page, size, ...(status && { status }) },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching gift requests:", error.message);
      throw error;
    }
  },

  // GET /api/gift-requests/my-requests
  getMyGiftRequests: async (page = 0, size = 10) => {
    try {
      const response = await axiosInstance.get("/api/gift-requests/my-requests", {
        params: { page, size },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching my gift requests:", error.message);
      throw error;
    }
  },

  // GET /api/gift-requests/{id}
  getGiftRequestById: async (id) => {
    try {
      const response = await axiosInstance.get(`/api/gift-requests/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching gift request with ID ${id}:`, error.message);
      throw error;
    }
  },

  // POST /api/gift-requests
  createGiftRequest: async (giftId, notes = "") => {
    try {
      const response = await axiosInstance.post("/api/gift-requests", {
        giftId,
        notes,
      });
      return response.data;
    } catch (error) {
      console.error("Error creating gift request:", error.message);
      throw error;
    }
  },

  // PUT /api/gift-requests/{id}/accept
  acceptGiftRequest: async (id) => {
    try {
      const response = await axiosInstance.put(`/api/gift-requests/${id}/accept`);
      return response.data;
    } catch (error) {
      console.error(`Error accepting gift request with ID ${id}:`, error.message);
      throw error;
    }
  },

  // PUT /api/gift-requests/{id}/reject
  rejectGiftRequest: async (id, reason) => {
    try {
      const response = await axiosInstance.put(`/api/gift-requests/${id}/reject`, { reason });
      return response.data;
    } catch (error) {
      console.error(`Error rejecting gift request with ID ${id}:`, error.message);
      throw error;
    }
  },

  // PUT /api/gift-requests/{id}/cancel
  cancelGiftRequest: async (id) => {
    try {
      const response = await axiosInstance.put(`/api/gift-requests/${id}/cancel`);
      return response.data;
    } catch (error) {
      console.error(`Error canceling gift request with ID ${id}:`, error.message);
      throw error;
    }
  },
};
